import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useAuth } from '../aws/AuthContext';
import { message } from 'antd';

export const useCategoriasClientes = () => {
    const { getJwtToken } = useAuth();
    const API_URL = process.env.REACT_APP_API_URL;
    const queryClient = useQueryClient();

    // 1. Obtener todas las categorias
    const getCategorias = useQuery({
        queryKey: ['categorias_cliente'],
        queryFn: async () => {
            const token = await getJwtToken();
            const res = await axios.get(`${API_URL}/v1-categorias-cliente`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return res.data;
        }
    });

    // 2. Crear nueva categoria cliente
    const saveCategoria = useMutation({
        mutationFn: async (payload) => {
            const token = await getJwtToken();
            if (payload.id) {
                return await axios.put(`${API_URL}/v1-categorias-cliente/${payload.id}`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            } else {
                return await axios.post(`${API_URL}/v1-categorias-cliente`, payload, {
                    headers: { Authorization: `Bearer ${token}` }
                });
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['categorias_cliente'] });
            message.success('Categoría guardada correctamente');
        },
        onError: (err) => {
            message.error(err.response?.data?.error || 'Error al guardar la categoría');
        }
    });

    // 3. Eliminar categorias
    const deleteCategoria = useMutation({
        mutationFn: async (id) => {
            const token = await getJwtToken();
            return await axios.delete(`${API_URL}/v1-categorias-cliente/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['categorias_cliente'] });
            message.success('Categoría eliminada exitosamente');
        },
        onError: (err) => {
            message.error(err.response?.data?.error || 'Error al eliminar la categoría');
        }
    });

    return {
        categorias: getCategorias.data || [],
        isLoading: getCategorias.isLoading,
        refetchCategorias: getCategorias.refetch,
        saveCategoria,
        deleteCategoria
    };
};